import { httpCreate } from './http';
import conf from '@/config';

const http = httpCreate(conf.surveyApipath + '/survey/');

export const survey = {
    getSurveyListV2(params) {
		return http.get(`base/0`, { params });
	},
	getQuestionnaireAndVote(params) {
		return http.get(`base/${params.type}`, { params });
	},
	//获取活动列表
	getSurveyList(visitType) {
		return http.get(`getActivity/${visitType}`);
	},
	//创建问卷和投票
	addQuestionnaireAndVote(data) {
		return http.post('', data);
	},
	//编辑问卷和投票
	setQuestionnaireAndVote(data) {
		return http.put('', data);
	},
	//删除问卷和投票
	deleteQuestionnaireAndVote(id) {
		return http.delete(id + '');
	},
	//复制问卷和投票
	copyQuestionnaireAndVote(id) {
		return http.post(`copy/${id}`);
	},
	//更改发布
	setQuestionnaireAndVoteStatus(id) {
		return http.put(`status/${id}`);
	},
	//获取（单个--详情）
	getSingleInfo(id) {
		return http.get(id + '');
	},
	// 发送邮件
	sendEmail(surveyId) {
		return http.put(`sendEmail/${surveyId}`);
	},
	// 发送邮件
	getSendNum(surveyId) {
		return http.get(`getSendNum/${surveyId}`);
	},
	// 导入邀请码模版
	importInviteCode(file) {
		return http.post('import/inviteCode', file);
	},
	// 导入选项
	options(file) {
		return http.post('import/option', file);
	},
    batchDelete(ids) {
        return http.delete('batchDel', {
            data: ids
        });
    },
    // 清空所有报名
    delAll(params) {
        return http.delete('delAll', { params });
    }
};
